import rawData from '@/shared/data/model_manufacturer_engineTypes.json';

export type EngineBaseType = 'ICE' | 'BEV' | 'PHEV' | 'HEV' | 'MHEV' | 'Rex' | 'Vätgas' | string;

export interface VehicleMappingRow {
  modelSeries: string;
  manufacturer: string;
  engineTypes: EngineBaseType[];
}

const rows: VehicleMappingRow[] = rawData as VehicleMappingRow[];

// Unique manufacturers
export const getManufacturers = (): string[] => {
  return Array.from(new Set(rows.map(r => r.manufacturer))).sort((a, b) => a.localeCompare(b));
};

// Model series by manufacturer
export const getModelSeriesByManufacturer = (manufacturer: string): string[] => {
  return rows
    .filter(r => r.manufacturer === manufacturer)
    .map(r => r.modelSeries)
    .sort((a, b) => a.localeCompare(b));
};

// Engine types by manufacturer + modelSeries
export const getEngineTypes = (manufacturer: string, modelSeries: string): EngineBaseType[] => {
  const hit = rows.find(r => r.manufacturer === manufacturer && r.modelSeries === modelSeries);
  return (hit?.engineTypes || []).filter(t => t !== 'Unknown').slice();
};

// Full search utilities
export const searchManufacturers = (q: string): string[] => {
  const ql = q.trim().toLowerCase();
  if (!ql) return getManufacturers();
  return getManufacturers().filter(m => m.toLowerCase().includes(ql));
};

export const searchModelSeries = (manufacturer: string, q: string): string[] => {
  const list = getModelSeriesByManufacturer(manufacturer);
  const ql = q.trim().toLowerCase();
  if (!ql) return list;
  return list.filter(ms => ms.toLowerCase().includes(ql));
};


